import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { toObservable } from '../../handlers/utils';
import {
  DialogContentBase,
  DialogRef,
  DialogSettings,
  KENDO_DIALOGS,
} from '@progress/kendo-angular-dialog';
import {
  DialogConfig,
  DialogField,
  DialogMode,
} from '@mysrc/models/shared-dialog';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import {
  KENDO_NUMERICTEXTBOX,
  KENDO_TEXTAREA,
  KENDO_TEXTBOX,
} from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-shared-dialog',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    AsyncPipe,
    ReactiveFormsModule,
    KENDO_DIALOGS,
    KENDO_DROPDOWNS,
    KENDO_TEXTAREA,
    KENDO_TEXTBOX,
    KENDO_NUMERICTEXTBOX,
  ],
  templateUrl: './shared-dialog.component.html',
  styleUrls: ['./shared-dialog.component.scss'],
})
export class SharedDialogComponent extends DialogContentBase {
  formGroup = this.fb.group({});
  set additionalDetails(config: DialogConfig) {
    this.mode = config.mode;
    if (config && config.fields && config.fields.length) {
      this.setFormGroup(config.fields);
      this.formConfig = config.fields;
    }
  }
  formConfig!: DialogField[];
  mode: DialogMode = 'confirmation';
  config!: DialogSettings;

  constructor(public dialog: DialogRef, private readonly fb: FormBuilder) {
    super(dialog);
  }

  setFormGroup(config: any[]): void {
    const group: Record<string, any> = {};
    config.forEach((field) => {
      group[field.key] = [field.value || ''];
    });
    this.formGroup = this.fb.group(group);
    config.forEach((field) => {
      if (field.type === 'select' && field.options) {
        toObservable(field.options).subscribe((opts) => (field.options = opts));
      }

      if (field.dependsOn && field.fetchOptions) {
        this.formGroup?.get(field.dependsOn)?.valueChanges.subscribe((val) => {
          toObservable(field.fetchOptions!(val)).subscribe((opts) => {
            field.options = opts;
            this.formGroup?.get(field.key)?.setValue(null);
          });
        });
      }
    });
  }

  isArray<T = any>(value: any): value is Array<T> {
    return Array.isArray(value);
  }
}
